import axios from 'axios'

export const getUserNotifications = () => {
  const token = axios.defaults.headers.common['Authorization']

  if (!token) return Promise.reject("Can't init messages without token")

  return axios.get(`${window.config.urls.socketUrl}notifications`, {
    headers: {
      'x-api-version': '1.0-user',
    },
  })
}

export const negotiateSignalR = async () => {
  return await axios.post(
    `${window.config.urls.socketUrl}negotiate`,
    {},
    {
      headers: {
        'x-api-version': '1.0-user',
      },
    }
  )
}

export const setRead = (notificationId: string) => {
  return axios.delete(
    `${window.config.urls.socketUrl}notifications/${notificationId}/read`,
    {
      headers: {
        'x-api-version': '1.0-user',
      },
    }
  )
}
